import { ApiIntegration } from '@app/_shared/interfaces/http/api-integration';
import { DataObject, ErrorObject } from '@app/_shared/interfaces/http/data';
import { removeById, replaceById } from '@app/_shared/support/array/replaceById';
import { Action, createReducer, on } from '@ngrx/store';
import * as IntegrationsActions from './integrations.actions';

export const integrationsFeatureKey = 'integrations';

export interface State {
  loading: boolean;
  saving: boolean;
  connected: boolean;
  deleting: boolean;
  deleted: boolean;
  apiIntegrations: DataObject<ApiIntegration>[];
  error: ErrorObject | null;
}

export const initialState: State = {
  saving: false,
  apiIntegrations: [],
  error: null,
  loading: false,
  connected: false,
  deleting: false,
  deleted: false,
};

const featureReducer = createReducer(
  initialState,
  on(IntegrationsActions.setSaving, (state, data) => ({ ...state, saving: data.saving, error: null })),
  on(IntegrationsActions.loadIntegrations, (state) => ({
    ...state,
    loading: true,
    connected: false,
    error: null,
    deleted: false,
    deleting: false,
  })),
  on(IntegrationsActions.loadIntegrationsSuccess, (state, data) => ({
    ...state,
    loading: false,
    apiIntegrations: data.data,
  })),
  on(IntegrationsActions.loadIntegrationsFailure, (state, error) => ({
    ...state,
    error: error,
    loading: false,
  })),
  on(IntegrationsActions.createIntegration, (state) => ({ ...state, saving: true, connected: false, error: null })),
  on(IntegrationsActions.createIntegrationSuccess, (state, data) => ({
    ...state,
    saving: false,
    connected: true,
    apiIntegrations: [...state.apiIntegrations, data.data],
  })),
  on(IntegrationsActions.createIntegrationFailed, (state, error) => ({
    ...state,
    saving: false,
    error: error,
  })),
  on(IntegrationsActions.updateIntegration, (state) => ({ ...state, saving: true, connected: false, error: null })),
  on(IntegrationsActions.updateIntegrationSuccess, (state, response) => ({
    ...state,
    apiIntegrations: replaceById(state.apiIntegrations, response.data.id, response.data),
    saving: false,
    connected: true,
  })),
  on(IntegrationsActions.updateIntegrationFailed, (state, error) => ({
    ...state,
    saving: false,
    error: error,
  })),
  on(IntegrationsActions.deleteIntegration, (state) => ({
    ...state,
    connected: false,
    loading: false,
    deleting: true,
    deleted: false,
    error: null,
  })),
  on(IntegrationsActions.deleteIntegrationSuccess, (state, response) => ({
    ...state,
    apiIntegrations: removeById(state.apiIntegrations, response.id),
    deleting: false,
    deleted: true,
  })),
  on(IntegrationsActions.deleteIntegrationFailed, (state, error) => ({
    ...state,
    deleting: false,
    deleted: false,
    error: error,
  })),
  on(IntegrationsActions.clearRequestStates, (state) => ({
    ...state,
    loading: false,
    connected: false,
    error: null,
    deleted: false,
    deleting: false,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return featureReducer(state, action);
}
